import Notify from 'quasar/src/plugins/Notify.js';;

export function showNotifyError(message) {
  Notify.create({
    message,
    color: "red-9",
    position: "top",
  });
}